var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/jszip/node_modules/core-js/library/modules/_cof.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_cof.js
// module chunks = common